import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Message, MESSAGE_THREAD_TYPE } from '@univacity/shared/types';
import { MessagesEntity } from './messages.models';
import {
  MESSAGES_FEATURE_KEY,
  MessagesState,
  messagesAdapter,
} from './messages.reducer';

// Lookup the 'Messages' feature state managed by NgRx
export const selectMessagesState =
  createFeatureSelector<MessagesState>(MESSAGES_FEATURE_KEY);

const { selectAll, selectEntities } = messagesAdapter.getSelectors();

export const selectMessagesLoading = createSelector(
  selectMessagesState,
  (state: MessagesState) => state.loading
);

export const selectUnread = createSelector(
  selectMessagesState,
  (state: MessagesState) => state.unread
);
export const selectInbox = createSelector(
  selectMessagesState,
  (state: MessagesState) => state.inbox
);

export const selectMessagesError = createSelector(
  selectMessagesState,
  (state: MessagesState) => state.error
);
export const messagePagination = createSelector(
  selectMessagesState,
  (state: MessagesState) => state.messagePagination
);

export const selectAllMessages = createSelector(
  selectMessagesState,
  (state: MessagesState) => selectAll(state)
);
export const selectAllMessageThreads = createSelector(
  selectAllMessages,
  (entities: MessagesEntity[]) => entities.map((e) => e.thread)
);

export const selectMessagesEntities = createSelector(
  selectMessagesState,
  (state: MessagesState) => selectEntities(state)
);

export const selectSelectedId = createSelector(
  selectMessagesState,
  (state: MessagesState) => state.selected
);
export const selectSelectedMessage = createSelector(
  selectMessagesState,
  (state: MessagesState) =>
    state.selected ? state.entities[state.selected] : null
);
export const selectSelectedThread = createSelector(
  selectSelectedMessage,
  (entity?: MessagesEntity | null) => (entity ? entity.thread : null)
);
export const selectSelectedMessages = createSelector(
  selectInbox,
  selectSelectedId,
  (inbox: Message[], id?: string | null) =>
    id
      ? inbox
          .filter((m) => m.thread === id)
          .sort((a, b) =>
            new Date(a.createdAt) > new Date(b.createdAt) ? 1 : -1
          )
      : []
);

export const selectEntity = (id: string) =>
  createSelector(selectMessagesEntities, (entities) => entities[id]);
export const fetchThreadUnreadByType = (
  type: MESSAGE_THREAD_TYPE,
  reference: string
) =>
  createSelector(selectAllMessages, (entities) => {
    const entity = entities.find(
      (e) => e.thread.type === type && e.thread.reference === reference
    );
    return entity?.unread || 0;
  });
